import { render, staticRenderFns } from "./import-2.vue?vue&type=template&id=5d47351d&"
import script from "./import-2.vue?vue&type=script&lang=js&"
export * from "./import-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports